import React, {Fragment, useContext, useEffect, useState} from "react";
import CardContainer from "../../../components/CardContainer";
import Card from "../../../components/Card";
import {Link} from "react-router-dom";
import {LoaderContext} from "../../../context/LoaderContext";
import ModalConfirm from "../../../components/ModalConfirm";
import NsDataTable from "../../../components/tabelle/NsDataTable";
import {deleteModalitaPagamentoApi, getModalitaPagamentoApi} from "../../../services/QuoteServices";

function ListModalitaPag() {

    const [loadingData, setLoadingData] = useState(true);
    const [data, setData] = useState([]);
    const [modalitaPagSel, setModalitaPagSel] = useState(null);
    const [show, setShow] = useState(false);

    const {startChiamata, endChiamata} = useContext(LoaderContext);

    async function getModalitaPag() {
        startChiamata();
        const response = await getModalitaPagamentoApi();
        setData(response.data.data);
        setLoadingData(false);
        endChiamata();
    }

    useEffect(() => {
        if (loadingData === true) {
            getModalitaPag()
        }
    }, []);

    const openModalDel = (utente) => {
        setModalitaPagSel(utente)
        setShow(true);
    }

    async function deleteModalitaPagamento() {
        setShow(false);
        startChiamata();
        const response = await deleteModalitaPagamentoApi(modalitaPagSel.id_modalita);
        setData(response.data.data);
        endChiamata();
    }

    return (
        <CardContainer>
            <Card
                icon={'fas fa-money-check-alt'}
                title={'Modalità di pagamento'}
                getBottoniDx={() =>
                    <Fragment>
                        <Link to="/upd-modalita-pag" className={"btn btn-card"}>
                            <i className="fas fa-plus-circle"/> Aggiungi
                        </Link>
                    </Fragment>
                }>
                <ModalConfirm
                    show={show}
                    handleClose={() => setShow(false)}
                    handleOk={deleteModalitaPagamento}
                    testo={"Sicuro di voler eliminare la modalità di pagamento: " + (modalitaPagSel
                        && (modalitaPagSel.id_modalita)) + "?"}/>
                {
                    loadingData ? (
                        <p>Caricamento in corso...</p>
                    ) : (
                        <NsDataTable
                            data={data}
                            columns={[
                                {
                                    name: 'Codice modalità',
                                    selector: row => row.id_modalita,
                                    sortable: true,
                                },
                                {
                                    name: 'Descrizione modalità',
                                    selector: row => row.descrizione,
                                    sortable: true,
                                },
                                {
                                    name: 'Ordinamento',
                                    selector: row => row.sort,
                                    sortable: true,
                                },
                                {
                                    name: '',
                                    selector: row => <Fragment>
                                        <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
                                            <div className="btn-group" role="group">
                                                <button id="btnGroupDrop1" type="button" className="btn btn-dark dropdown-toggle"
                                                        data-bs-toggle="dropdown" aria-expanded="false">
                                                    <i className="fa-solid fa-bars"></i>
                                                </button>
                                                <ul className="dropdown-menu" aria-labelledby="btnGroupDrop1">
                                                    <li>
                                                        <Link to={"/upd-modalita-pag/" + row.id_modalita}
                                                              className="dropdown-item"
                                                              data-toggle="tooltip" title="Modifica">
                                                            <i className="fas fa-pen"/> Modifica
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <button className="dropdown-item"
                                                                data-toggle="tooltip" title="Elimina" onClick={() => {
                                                            openModalDel(row)
                                                        }}>
                                                            <i className="fas fa-trash"/> Elimina
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </Fragment>,
                                    sortable: false,
                                    right: true,
                                }
                            ]}
                            addPagination={true}
                            funzioneFiltro={(item, filtro) => {
                                return (item.id_modalita && item.id_modalita.toLowerCase().includes(filtro.toLowerCase()))
                                    || (item.descrizione && item.descrizione.toLowerCase().includes(filtro.toLowerCase()))
                            }}
                        >
                        </NsDataTable>
                    )}
            </Card>
        </CardContainer>
    );
}

export default ListModalitaPag;
